"use strict";

/**
 * @file
 * Global utilities.
 */
(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.dropdown = {
    attach: function attach(context, settings) {
      var dropdowns = context.querySelectorAll('.dropdown');
      dropdowns.forEach(function (elem) {
        $(elem).superfish();
      });
    }
  };
  Drupal.behaviors.searchBox = {
    attach: function attach(context, settings) {
      var search = context.querySelector('.search__icon');

      if (!search || search.onclick) {
        return;
      }

      search.addEventListener('click', function () {
        search.parentNode.classList.toggle('search--open');
      });
    }
  };
  Drupal.behaviors.bxslider = {
    attach: function attach(context, settings) {
      $('.bxslider').bxSlider({
        infiniteLoop: true,
        auto: true,
        touchEnabled: typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1,
        pause: 8000,
        tickerHover: true,
        autoHover: true
      });
    }
  };
  Drupal.behaviors.downloadCount = {
    attach: function attach(context, settings) {
      $('.count-download', context).click(function (event) {
        event.preventDefault();
        var nodeId = $(this).attr('download-node');
        var nodeData = {
          'node-id': nodeId
        };
        var sessionToken = null;
        var targetUrl = $(this).attr('href');
        $.ajax({
          url: '/rest/session/token',
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          success: function success(data, status, xhr) {
            sessionToken = data;
            $.ajax({
              url: '/api/v1/download-count',
              method: 'POST',
              data: JSON.stringify(nodeData),
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-Token': sessionToken
              },
              success: function success(data, status, xhr) {
                //window.location.href = targetUrl;
                var downloadLink = document.createElement('a');
                downloadLink.href = targetUrl;
                var filename = targetUrl.replace(/^.*[\\\/]/, '');
                downloadLink.download = filename;
                downloadLink.click();
                document.body.removeChild(downloadLink);
              }
            });
          }
        });
      });
    }
  };
  Drupal.behaviors.swiper = {
    attach: function attach(context, settings) {
      var swipers = context.querySelectorAll('.swiper'); // check if there's any swiper

      if (!swipers.length) {
        return;
      }

      swipers.forEach(function (swiper) {
        var el = swiper.querySelector('.swiper-container'); // check if swiper has already been added to el

        if (el.hasOwnProperty('swiper')) {
          return;
        }

        var id = el.getAttribute('data-swiper-id');
        var config = getDefaultConfig(id);
        var slidesPerView = Number(el.getAttribute('data-swiper-slides'));
        var spaceBetween = Number(el.getAttribute('data-swiper-space-between'));
        var hasPagination = el.querySelector('.swiper-pagination');
        var lazyLoad = el.querySelectorAll('swiper-lazy');
        var fullscreenWrapper = swiper.querySelector('.fullscreen-swiper-wrapper');

        if (slidesPerView) {
          config = getColumnConfig(slidesPerView, spaceBetween, id);
        }

        if (hasPagination) {
          config.pagination = {
            el: '.swiper-pagination',
            type: 'bullets'
          };
        }

        config.loop = false; // Add fullscreen functionality

        if (fullscreenWrapper) {
          // Append wrapper to body.
          if (!document.body.classList.contains('.fullscreen-swiper-wrapper')) {
            fullscreenWrapper.remove();
            document.body.appendChild(fullscreenWrapper);
          } // Add click listener to each slide.


          config.on = {
            click: function click(e) {
              openFullscreenSwiper(this.realIndex, swiper);
            }
          };
        }

        new Swiper(el, config);
      });
    }
  };
  Drupal.behaviors.swiper_gallery = {
    attach: function attach(context, settings) {
      var swipers = context.querySelectorAll('.swiper-gallery'); // check if there's any swiper

      if (!swipers.length) {
        return;
      }

      swipers.forEach(function (swiper) {
        var swiperTop = swiper.querySelector('.swiper-container.gallery-top');
        var fullscreenWrapper = swiper.querySelector('.fullscreen-swiper-wrapper');

        if (fullscreenWrapper && !document.body.classList.contains('.fullscreen-swiper-wrapper')) {
          fullscreenWrapper.remove();
          document.body.appendChild(fullscreenWrapper);
        }

        var swiperEl = new Swiper(swiperTop, {
          spaceBetween: 10,
          setWrapperSize: true,
          navigation: {
            nextEl: '.swiper-button-next-gallery',
            prevEl: '.swiper-button-prev-gallery'
          },
          on: {
            click: function click(e) {
              if (!fullscreenWrapper) {
                return;
              }

              openFullscreenSwiper(this.realIndex, swiper);
            }
          }
        });

        if (swiperEl.slides.length < 2) {
          var _swiperEl$pagination$, _swiperEl$navigation$, _swiperEl$navigation$2;

          swiperEl.$wrapperEl.addClass('disabled');
          (_swiperEl$pagination$ = swiperEl.pagination.$el) === null || _swiperEl$pagination$ === void 0 ? void 0 : _swiperEl$pagination$.addClass('disabled');
          (_swiperEl$navigation$ = swiperEl.navigation.$nextEl) === null || _swiperEl$navigation$ === void 0 ? void 0 : _swiperEl$navigation$.addClass('swiper-button-hidden');
          (_swiperEl$navigation$2 = swiperEl.navigation.$prevEl) === null || _swiperEl$navigation$2 === void 0 ? void 0 : _swiperEl$navigation$2.addClass('swiper-button-hidden');
        }
      });
    }
  };
  Drupal.behaviors.expandable_content = {
    attach: function attach(context) {
      var items = context.querySelectorAll('.expandable');

      if (!items.length) {
        return;
      } // Run it through an each in case there's more than one on the same page


      items.forEach(function (item) {
        var toggler = item.querySelector('.expandable__toggle');

        if (!toggler) {
          return false;
        }

        var itemContent = item.querySelector('.expandable-content');
        toggler.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();

          if (!itemContent) {
            return;
          }

          item.classList.toggle('is--open');

          if (item.classList.contains('is--open')) {
            itemContent.style.maxHeight = itemContent.scrollHeight + 'px';
            return;
          }

          itemContent.style.maxHeight = '0';
        });
      });
    }
  };
  Drupal.behaviors.modal = {
    attach: function attach(context) {
      var modalWrappers = context.querySelectorAll('.modal-wrapper');

      if (!modalWrappers.length) {
        return;
      }

      modalWrappers.forEach(function (wrapper) {
        var trigger = wrapper.querySelector('.modal-trigger');

        if (!trigger) {
          return;
        }

        if (trigger.onclick) {
          return;
        }

        var contentId = trigger.getAttribute("data-target");

        if (!contentId) {
          return;
        }

        var content = wrapper.querySelector(".".concat(contentId));

        if (!content) {
          return;
        }

        var modal = new tingle.modal({
          closeMethods: ['button', 'escape'],
          cssClass: ["tingle-".concat(contentId)]
        });
        modal.setContent(content);
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          modal.open();
        });
      });
    }
  };

  function getDefaultConfig(id) {
    return {
      init: true,
      updateOnWindowResize: true,
      setWrapperSize: true,
      loop: false,
      speed: 400,
      spaceBetween: 0,
      hashNavigation: {
        watchState: true
      },
      navigation: {
        nextEl: id ? ".swiper-button-next-".concat(id) : '.swiper-button-next',
        prevEl: id ? ".swiper-button-prev-".concat(id) : '.swiper-button-prev'
      }
    };
  }

  ;

  function getColumnConfig(slidesPerView, spaceBetween, id) {
    // @TODO improve dynamic values for swiper
    return {
      init: true,
      slidesPerView: slidesPerView || 4,
      spaceBetween: spaceBetween || 0,
      navigation: {
        nextEl: id ? ".swiper-button-next-".concat(id) : '.swiper-button-next',
        prevEl: id ? ".swiper-button-prev-".concat(id) : '.swiper-button-prev'
      },
      on: {
        init: function init() {
          var bp = this.params.breakpoints[this.currentBreakpoint];
          var prev = this.el.querySelector(this.params.navigation.prevEl);
          var next = this.el.querySelector(this.params.navigation.nextEl);

          if (this.slides.length <= bp.slidesPerView) {
            prev.classList.add(this.params.navigation.hiddenClass);
            next.classList.add(this.params.navigation.hiddenClass);
            this.allowTouchMove = false;
          }
        },
        breakpoint: function breakpoint() {
          if (this.slides.length == 0) {
            return;
          }

          var bp = this.params.breakpoints[this.currentBreakpoint];
          var prev = this.el.querySelector(this.params.navigation.prevEl);
          var next = this.el.querySelector(this.params.navigation.nextEl);

          if (this.slides.length <= bp.slidesPerView) {
            prev.classList.add(this.params.navigation.hiddenClass);
            next.classList.add(this.params.navigation.hiddenClass);
            this.allowTouchMove = false;
          } else {
            prev.classList.remove(this.params.navigation.hiddenClass);
            next.classList.remove(this.params.navigation.hiddenClass);
            this.allowTouchMove = true;
          }
        }
      },
      // Responsive breakpoints
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        680: {
          slidesPerView: 2,
          spaceBetween: spaceBetween || 0
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: spaceBetween || 0
        },
        // when window width is >= 1380px
        1380: {
          slidesPerView: 4,
          spaceBetween: spaceBetween || 0
        }
      }
    };
  }

  ;

  function openFullscreenSwiper(initialSlideNumber, context) {
    var mainSwiperMarkup = context.querySelector('.swiper-container').innerHTML;
    var wrapper = document.querySelector('.fullscreen-swiper-wrapper');
    var swiperContainer = document.querySelector('.fullscreen-swiper');
    var offset = window.pageYOffset;
    wrapper.style.display = 'block';
    swiperContainer.innerHTML = mainSwiperMarkup;
    var fullscreenSwiper = new Swiper('.fullscreen-swiper', {
      pagination: '.swiper-pagination',
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      slidesPerView: 1,
      centeredSlides: true,
      paginationClickable: true,
      spaceBetween: 10,
      loop: false,
      initialSlide: initialSlideNumber
    });
    $('.fullscreen-swiper-backdrop, .fullscreen-swiper').fadeIn();
    $('body, html').addClass('no-scroll');
    document.body.style.top = -offset + 'px';
    $('.fullscreen-swiper-close').on('click', function () {
      $('.fullscreen-swiper').hide().empty();
      $('.fullscreen-swiper-wrapper').fadeOut();
      $('body, html').removeClass('no-scroll');
      $('.fullscreen-swiper-backdrop').fadeOut();
      document.body.style.top = null;
      window.scrollTo({
        top: offset,
        behavior: 'instant'
      });
      fullscreenSwiper.destroy();
    });
  }
})(jQuery, Drupal);